import React, { useEffect, useState } from "react";
import TiltArrow from "../../../icons/TiltArrow";
import Pusher from "pusher-js";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
interface LiveAuctionCardProps {
  assetType: string;
  latestPrice: string;
  subAssetType: string;
  eventName: string;
  biddersCount: number;
  eventUuid: string;
}

interface LiveAuctionDataProps {
  title: string;
  value: string;
  children: LiveAuctionCardProps[];
}
export const LiveAuctionCard = ({
  assetType,
  subAssetType,
  eventName,
  latestPrice,
  biddersCount,
  eventUuid,
}: LiveAuctionCardProps) => {
  const router = useRouter();
  const [latestBidPrice, setLatestBidPrice] = useState(latestPrice);
  const accessToken = useSelector((state: any) => state.bankerAuth.accessToken);
  const bankerName = useSelector(
    (state: any) => state.bankerAuth.user?.profile?.bio?.full_name
  );
  useEffect(() => {
    Pusher.logToConsole = false;
    let authConfig = {};
    let channelId = `auction-event-${eventUuid}`;

    if (process.env.NEXT_PUBLIC_ENABLE_BIDDER_ACTIVITY === "true") {
      authConfig = {
        authEndpoint: `${process.env.NEXT_PUBLIC_API_URL}/auction/pusher/auth`,
        auth: {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            event_uuid: eventUuid,
            user_type: "banker",
            user_name: bankerName,
          },
        },
      };
      channelId = `presence-${channelId}`;
    }
    const pusher = new Pusher(`${process.env.NEXT_PUBLIC_PUSHER_KEY}`, {
      cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
      ...authConfig,
    });

    // const channelId = `auction-event-${eventUuid}`;
    const channel = pusher.subscribe(channelId);

    channel.bind("bidding_value_has_been_changed", (data: any) => {
      if (data) {
        setLatestBidPrice(
          new Intl.NumberFormat("en-IN").format(Number(data?.final_amount))
        );
      }
    });

    pusher.connection.bind("error", function (err: any) {
      if (err?.error?.data?.code === 4004) {
        console.log(">>> detected limit error");
      } else if (err?.data?.code === 1006) {
        // Websocket: CLOSED ABNORMALLY
      }
    });

    pusher.connection.bind("disconnected", function (err: any) {
      console.log(">>> disconnected");
    });

    pusher.connection.bind("connected", function (err: any) {
      console.log("connected", pusher.sessionID);
    });

    return function cleanup() {
      pusher.disconnect();
    };
  }, []);
  return (
    // Original designs
    // <div className="bg-white p-3 h-fit min-h-[94px]">
    //   <div className="flex justify-between items-center border-b pb-1">
    //     <div className="flex items-center space-x-1">
    //       <p className="font-openSans capitalize max-w-[90px] font-normal text-web-body-sm leading-4 text-brand-bgBlack">
    //         {assetType} {subAssetType}
    //       </p>

    //       <p className="font-openSans font-normal  max-w-[146px] truncate text-mobile-body-xsm leading-[14px] text-brand-textGrey">
    //         {eventName}
    //       </p>
    //     </div>
    //     <div
    //       className="hover:cursor-pointer"
    //       onClick={() => {
    //         router.push(`/dashboard/live-events/${eventUuid}`);
    //       }}
    //     >
    //       <TiltArrow
    //         stroke="none"
    //         className="h-6 w-6 stroke-brand-bgBlack fill-[#EEEEEE]  rounded-full"
    //       />
    //     </div>
    //   </div>
    //   {biddersCount && biddersCount > 0 ? (
    //     <>
    //       {" "}
    //       <div className="flex space-x-1 items-center mt-2">
    //         <p className="font-openSans font-normal text-web-body-sm leading-4 text-brand-bgBlack">
    //           Latest Bidding Price
    //         </p>
    //         <p className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-orange">
    //           {latestBidPrice ? "₹" + latestBidPrice : "-"}
    //         </p>
    //       </div>
    //       <p className="font-openSans font-semibold text-mobile-body-xsm leading-3 text-brand-bgSuccessGreen mt-1.5">
    //         {biddersCount} people are participating in this auction
    //       </p>
    //     </>
    //   ) : (
    //     <>
    //       <p className="font-openSans font-normal text-web-body-sm leading-4 text-brand-textLightGrey mt-2">
    //         No Participants Yet
    //       </p>
    //     </>
    //   )}
    // </div>

    <div className="bg-white p-3 h-fit min-h-[94px]">
      <div className="flex justify-between items-center border-b pb-1">
        <div className="">
          <p className="font-openSans capitalize max-w-[200px] truncate font-normal text-web-body-sm leading-4 text-brand-bgBlack">
            {assetType} {subAssetType}
          </p>
          <p className="font-openSans font-normal mt-1  max-w-[200px] truncate text-mobile-body-xsm leading-[14px] text-brand-textGrey">
            {eventName}
          </p>
        </div>
        <div
          className="hover:cursor-pointer"
          onClick={() => {
            window.open(`/dashboard/live-events/${eventUuid}`);
          }}
        >
          <TiltArrow
            stroke="none"
            className="h-6 w-6 stroke-brand-bgBlack fill-[#EEEEEE]  rounded-full"
          />
        </div>
      </div>
      {biddersCount && biddersCount > 0 ? (
        <>
          {" "}
          <div className="flex space-x-1 items-center mt-2">
            <p className="font-openSans font-normal text-web-body-sm leading-4 text-brand-bgBlack">
              Latest Bidding Price
            </p>
            <p className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-orange">
              {latestBidPrice && latestBidPrice !== "0"
                ? "₹" + latestBidPrice
                : "N/A"}
            </p>
          </div>
          <p className="font-openSans font-semibold text-mobile-body-xsm leading-3 text-brand-bgSuccessGreen mt-1.5">
            {biddersCount} people are participating in this auction
          </p>
        </>
      ) : (
        <>
          <p className="font-openSans font-normal text-web-body-sm leading-4 text-brand-textLightGrey mt-2">
            No Participants Yet
          </p>
        </>
      )}
    </div>
  );
};

export default LiveAuctionCard;
